import { computed, defineComponent } from 'vue';
import { IonButton, IonImg, IonIcon } from '@ionic/vue';
import { lockClosed, chevronUp, chevronDown, settings, play, keySharp, logoYoutube, logoSnapchat, logoTiktok, logoFacebook, logoInstagram, mail, globe, call } from 'ionicons/icons';
import { EmailComposer } from "@awesome-cordova-plugins/email-composer";
import { isPlatform } from '@ionic/vue';
export default defineComponent({
    setup(props) {
        const callSchool = () => {
            window.open(`tel:${props.phone}`, '_self');
        };
        const emailSchool = () => {
            if (isPlatform('capacitor')) {
                EmailComposer.open({ to: props.email, isHtml: true });
            }
            else {
                window.open(`mailto:${props.email}`, '_self');
            }
        };
        const lockedImage = computed(() => {
            return new URL('@/assets/png/lock.png', import.meta.url).href;
        });
        const openUrl = (url) => {
            if (!url.match(/^https?:\/\//i))
                url = 'http://' + url;
            window.open(url, '_blank');
        };
        const isValidBase64 = (str) => /^[A-Za-z0-9+/]+={0,2}$/.test(str);
        const formattedDescriptionImage = computed(() => isValidBase64(props.descriptionImage) ? `data:image/png;base64,${props.descriptionImage}` : props.descriptionImage);
        return {
            lockedImage,
            lockClosed,
            chevronUp,
            chevronDown,
            settings,
            play,
            key: keySharp,
            logoYoutube,
            logoSnapchat,
            logoTiktok,
            logoFacebook,
            logoInstagram,
            globe,
            logoMail: mail,
            call,
            callSchool,
            emailSchool,
            openUrl,
            formattedDescriptionImage
        };
    },
    props: {
        color: String,
        image: String,
        descriptionImage: {
            type: String,
            default: null
        },
        descriptionImageAlt: {
            type: String,
            default: ''
        },
        title: String,
        subtitle: String,
        isLocked: Boolean,
        text: String,
        action: Function,
        hasMainAction: {
            type: Boolean,
            default: true
        },
        hasSettings: {
            type: Boolean,
            default: false
        },
        settingsUrl: {
            type: String,
            default: "/preferences"
        },
        email: {
            type: String,
            default: null
        },
        phone: {
            type: String,
            default: null
        },
        website: {
            type: String,
            default: null
        },
        instagram: {
            type: String,
            default: null
        },
        facebook: {
            type: String,
            default: null
        },
        tiktok: {
            type: String,
            default: null
        },
        snapchat: {
            type: String,
            default: null
        },
        youtube: {
            type: String,
            default: null
        }
    },
    components: {
        IonButton,
        IonImg,
        IonIcon
    },
    data() {
        return {
            expandedText: false
        };
    }
});
